// extracted by mini-css-extract-plugin
module.exports = {"link":"_l2ICYh_6"};